module.exports = __webpack_public_path__ + "static/img/logo01.17a552f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo01.png
// module id = EeYu
// module chunks = 68